var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import styled from "../themes/styled";
import * as SS from "styled-system";
import { useInView } from "react-intersection-observer";
import { lazyOptions, placeholderSrc } from "./shared";
var Image = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n    ", ";\n"], ["\n    box-sizing: border-box;\n    ", ";\n"])), SS.space);
var LazyImage = function (_a) {
    var src = _a.src, style = _a.style, placeholder = _a.placeholder, width = _a.width, height = _a.height, rest = __rest(_a, ["src", "style", "placeholder", "width", "height"]);
    var _b = useInView(lazyOptions), ref = _b[0], inView = _b[1];
    var _c = useState(false), isLoaded = _c[0], setLoaded = _c[1];
    var styles = __assign({ transition: "opacity 300ms", opacity: isLoaded ? 1 : 0, display: "block", width: "100%", height: "auto" }, style);
    var w = width;
    var h = height;
    if (placeholder && placeholder[0]) {
        w = placeholder[0];
    }
    if (placeholder && placeholder[1]) {
        h = placeholder[1];
    }
    return (React.createElement(Image, __assign({ ref: ref, width: w, height: h }, rest, { src: inView ? src : placeholder ? placeholderSrc(placeholder) : "", style: styles, onLoad: inView ? function () { return setLoaded(true); } : function () { } })));
};
export default (function (_a) {
    var _b = _a.lazyLoad, lazyLoad = _b === void 0 ? true : _b, placeholder = _a.placeholder, style = _a.style, rest = __rest(_a, ["lazyLoad", "placeholder", "style"]);
    return lazyLoad ? (React.createElement(LazyImage, __assign({ placeholder: placeholder, style: style }, rest))) : (React.createElement(Image, __assign({ style: __assign({ display: "block", width: "100%", height: "auto" }, style) }, rest)));
});
var templateObject_1;
//# sourceMappingURL=Image.js.map